module.exports = __webpack_public_path__ + "img/5-2.8e409316.jpg";